import { TReduxActions } from '../../../common/actions';
import { EFetchMapDataActionType } from '../../../common/actions/fetchMapData/types';
import { IFrecklesFeaturesMap } from '../../../common/types/freckles';

export const defaultState: IFrecklesFeaturesMap = {};

export const frecklesReducer = (state = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      return action.payload.freckles;
    }
    case EFetchMapDataActionType.Failed: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
};
